package us.laantech.common.util

import us.laantech.common.dto.InventoryDTO
import kotlin.collections.fold
import kotlin.math.roundToLong


fun List<InventoryDTO>.computeEndingInventory(): InventoryDTO {

    val createdAt = this.maxOfOrNull { it.createdAt ?: 0L }
    val totalAdded = this.sumOf { it.addedCount ?: 0L }

    val totalWeightedCostCents = this.sumOf { (it.unitCostCents ?: 0L) * (it.addedCount ?: 0L) }
    val averageUnitCostCents =
        if (totalAdded > 0L) (totalWeightedCostCents.toDouble() / totalAdded).roundToLong()
        else 0L

    val inventory = InventoryDTO(
        createdAt = createdAt,
        addedCount = totalAdded,
        unitCostCents = averageUnitCostCents,
        soldCount = this.sumOf { it.soldCount ?: 0L },
        expiredCount = this.sumOf { it.expiredCount ?: 0L },
        damagedCount = this.sumOf { it.damagedCount ?: 0L },
        writeOffCount = this.sumOf { it.writeOffCount ?: 0L },
        storeUseCount = this.sumOf { it.storeUseCount ?: 0L },
        lostCount = this.sumOf { it.lostCount ?: 0L },
    )

    return inventory
}